/* global $ */

class Loader {
  constructor() {
    this.$container = $('.Loading');
    this.$jsSelector = $('.js-loading');
    const keyName = 'visited';
    const keyValue = true;

    if (!sessionStorage.getItem(keyName)) {
      sessionStorage.setItem(keyName, keyValue);
      $('.LoadingIcon').addClass('LoadingIcon--show');
      setTimeout(() => {
        this.fadeOutMethod();
      }, 500);
    } else {
      setTimeout(() => {
        this.fadeOutMethod();
      }, 500);
    }
  }

  fadeOutMethod() {
    /*
    this.$container.fadeOut(1000, function () {
      $(this).remove();
    });
    */
    this.$container.addClass('is-loaded');
    this.$jsSelector.addClass('is-loaded');
  }
}
export default Loader;
